<template>
  <div class="page">
    <div class="seiten-kopf">
      <router-link to="/rezepte" class="seiten-kopf-zurueck" aria-label="Zurück">
        <font-awesome-icon icon="fa-solid fa-arrow-left" />
      </router-link>
      <h1>Eingefrorene Rezepte</h1>
    </div>

    <p v-if="Fehlermeldung" class="error-message">{{ Fehlermeldung }}</p>

    <p v-if="EingefroreneRezepte.length === 0" class="hint-message">
      Noch keine Rezepte als eingefroren markiert.
    </p>

    <template v-else>
      <div class="liste-suche">
        <input v-model="Suche" type="text" placeholder="Suchen..." class="liste-suche-feld" />
        <button type="button" class="btn btn-secondary liste-falten-btn" @click="FoldUnfoldAlle">
          {{ AlleEingeklappt ? 'Ausklappen' : 'Einklappen' }}
        </button>
      </div>
      <p v-if="Gruppen.length === 0" class="hint-message">Keine Einträge gefunden.</p>
      <div v-else class="eintrag-liste-scroll">
        <div class="kategorie-gruppe" v-for="Gruppe in Gruppen" :key="Gruppe.Kategorie">
          <h2 class="kategorie-titel" @click="KategorieToggeln(Gruppe.Kategorie)">
            <span>{{ Gruppe.Kategorie }}</span>
            <span class="kategorie-badge">{{ Gruppe.Eintraege.length }}</span>
            <font-awesome-icon icon="fa-solid fa-chevron-right" class="kategorie-pfeil" :class="{ 'kategorie-pfeil--offen': !GeklapptKategorien.includes(Gruppe.Kategorie) }" />
          </h2>
          <div v-show="!GeklapptKategorien.includes(Gruppe.Kategorie)" class="eintrag-liste">
            <div class="eintrag-zeile" v-for="Rezept in Gruppe.Eintraege" :key="Rezept.Id">
              <div class="eintrag-mit-bild">
                <img
                  v-if="Rezept.HatBild"
                  :src="RezeptBildUrl(Rezept)"
                  class="mini-bild"
                  alt=""
                  loading="lazy"
                  @error="$event.target.style.display = 'none'"
                />
                <div class="eintrag-info">
                  <span class="eintrag-name">🧊 {{ Rezept.Name }}</span>
                  <span class="eintrag-details">{{ ZutatenText(Rezept) }}</span>
                </div>
              </div>
              <div class="eintrag-aktionen">
                <router-link :to="`/rezepte/bearbeiten/${Rezept.Id}`" class="aktion-button">Bearbeiten</router-link>
                <button type="button" class="aktion-button loeschen" @click="Loeschen(Rezept)">Rezept löschen</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { Rezepte, RezepteLaden, RezeptLoeschen } from '../composables/useRezepte'
import { ZutatenLaden, ZutatFinden } from '../composables/useZutaten'
import { BildUrl } from '../composables/useBilder'

const KategorieReihenfolge = ['Frühstück', 'Vorspeise', 'Hauptgang', 'Nachspeise', 'Abendessen']

export default {
  name: 'RezepteEingefrorenView',
  data() {
    return {
      Rezepte,
      KategorieReihenfolge,
      Fehlermeldung: '',
      Suche: '',
      GeklapptKategorien: []
    }
  },
  async created() {
    await Promise.all([ZutatenLaden(), RezepteLaden()])
  },
  computed: {
    EingefroreneRezepte() {
      return this.Rezepte.filter(r => r.Eingefroren)
    },
    GefilterteRezepte() {
      const s = this.Suche.toLowerCase().trim()
      if (!s) return this.EingefroreneRezepte
      return this.EingefroreneRezepte.filter(r => r.Name.toLowerCase().includes(s))
    },
    AlleEingeklappt() {
      return this.Gruppen.length > 0 && this.GeklapptKategorien.length >= this.Gruppen.length
    },
    Gruppen() {
      return KategorieReihenfolge
        .map(Kategorie => ({
          Kategorie,
          Eintraege: this.GefilterteRezepte
            .filter(Rezept => (Rezept.Kategorien || []).includes(Kategorie))
            .slice()
            .sort((a, b) => a.Name.localeCompare(b.Name))
        }))
        .filter(Gruppe => Gruppe.Eintraege.length > 0)
    }
  },
  methods: {
    KategorieToggeln(Name) {
      const Index = this.GeklapptKategorien.indexOf(Name)
      if (Index === -1) {
        this.GeklapptKategorien.push(Name)
      } else {
        this.GeklapptKategorien.splice(Index, 1)
      }
    },
    FoldUnfoldAlle() {
      if (this.AlleEingeklappt) {
        this.GeklapptKategorien = []
      } else {
        this.GeklapptKategorien = this.Gruppen.map(g => g.Kategorie)
      }
    },
    RezeptBildUrl(Rezept) {
      return BildUrl('Rezept', Rezept.Id, Rezept.BildVersion)
    },
    ZutatenText(Rezept) {
      const Personen = Rezept.Personen
        ? `Für ${Rezept.Personen} ${Rezept.Personen === 1 ? 'Person' : 'Personen'}`
        : ''
      if (!Rezept.Zutaten || Rezept.Zutaten.length === 0) {
        return [Personen, 'Keine Zutaten hinterlegt'].filter(Boolean).join(' · ')
      }
      const Namen = Rezept.Zutaten
        .map(Zutat => {
          const Gefunden = ZutatFinden(Zutat.ZutatId)
          return Gefunden ? Gefunden.Name : Zutat.Name
        })
        .filter(Boolean)
        .join(', ')
      return [Personen, Namen].filter(Boolean).join(' · ')
    },
    async Loeschen(Rezept) {
      this.Fehlermeldung = ''
      if (confirm(`"${Rezept.Name}" wirklich löschen?`)) {
        try {
          await RezeptLoeschen(Rezept.Id)
        } catch (Fehler) {
          this.Fehlermeldung = Fehler.message
        }
      }
    }
  }
}
</script>
